import React from "react";
import Lottie from "lottie-react";
import SafatyAnimation from "../Images/Car_safety.json";
import { useTranslation, Trans } from "react-i18next";

function Safaty() {
  const { t, i18n } = useTranslation();
  return (
    <div className="safaty-section-wrapping pb-60">
      <div className="container">
        <div className="chooseuys-heading-wrap text-center d-flex flex-column align-items-center mt-4">
          <h2 className="main-heading">
            <Trans i18nKey="safety_title">
              Your <span>Safety</span> is our priority
            </Trans>
          </h2>
          <p>{t("safety_subtitle")}</p>
        </div>

        <div className="safaty-content row align-items-center">

          <div className="col-md-6">
            <h2>{t("safety_heading")}</h2>
            <p>
             {t("safety_desc")}
            </p>
            <button className="wave-btn">{t("safety_btn")}</button>
          </div>

          <div className="col-md-6 text-center">
            <div className="safaty-img-anim">
              <Lottie animationData={SafatyAnimation} loop={true} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Safaty;
